import { Footer } from "antd/es/layout/layout";
import React from "react";

const MyFooter: React.FC = () => {
  return (
    <Footer>
      <p>NON-INVESTMENT ADVICE</p>
    </Footer>
  );
};

export default MyFooter;
